<template>
    <confirm-default
            :msg="msg"
            :visible="visible"
            @close="onClose"
            @confirm="onConfirm"
    >
        <p class="text-center">{{msg}}</p>
    </confirm-default>
</template>

<script>
    import ConfirmDefault  from './ConfirmDefault.vue'
    export default {
        name: 'ConfirmDeleteMenu',
        emits: ['close_delete_menu', 'confirm_delete_menu'],
        components:{
            'confirm-default' : ConfirmDefault
        },
        props: {
            visible: false,
            msg: {
                type: String,
                default: '¿Confirmar el borrado del menú?'
            },
        },
        methods : {
            onClose () {
                this.$emit('close_delete_menu', true);
            },
            onConfirm () {
                this.$emit('confirm_delete_menu', true);
            }
        }
    }
</script>
